export function formatFurnishedState(furnishedState: string | string[]) {
    switch (furnishedState) {
        case 'furnished':
            return 'Furnished';
        case 'part_furnished':
            return 'Part furnished';
        case 'unfurnished':
            return 'Unfurnished';
        default:
            return '';
    }
}
